export function hasCypressRunning(): boolean {
  // @ts-ignore
  return !!window['Cypress'];
}
